import { useContext, createContext } from 'react';

import type { useRegistrationStatusInitialState } from '../hooks';

export const RegistrationContext = createContext({} as ReturnType<typeof useRegistrationStatusInitialState>);

export const RegistrationStatusProvider = RegistrationContext.Provider;

export const useRegistrationStatus = () => useContext(RegistrationContext);
